import { render } from "./StatsCards.vue?vue&type=template&id=6d7723ad"
import script from "./StatsCards.vue?vue&type=script&lang=js"
export * from "./StatsCards.vue?vue&type=script&lang=js"

import exportComponent from "/builds/angeloferraro/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__